import React from 'react';
import { Icon } from '../Icon/Icon';

export interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  type: 'checkbox' | 'radio';
}

export function Tickbox({ label, type, ...props }: Props) {
  return (
    <label className="relative flex text-[1.333em]">
      <input {...props} className="absolute top-0 left-0 w-6 h-6 opacity-0 peer" type={type} />
      <div className="flex flex-row items-center cursor-pointer select-none gap-3">
        <div className="flex-none mt-[1px] p-[5px] bg-white border border-gray-300 rounded peer-enabled:hover:border-blue-600 transition-colors duration-150">
          {/* Show checkmark only if checked */}
          <span className={`${props.checked || props.defaultChecked ? '' : 'invisible'} cursor-pointer`}>
            <Icon type="check-16" />
          </span>
        </div>
        <div className="flex-1 ml-2">{label}</div>
      </div>
    </label>
  );
}
